<template>
  <div
    class="w-full h-screen bg-gradient-to-r from-yellow-900 via-red-900 to-indigo-900 flex justify-center items-center"
  >
    <div class="container m-auto w-login">
      <div class="font-sans bg-white rounded-lg shadow-2xl pb-6">
        <div class="px-6">
          <div class="relative flex flex-wrap">
          
            <div class="w-full relative">
              <div class="mt-6">
                <form class="mt-8">
                  <div class="mx-auto max-w-lg">
                    <header>
                      <img src="../../assets/png/favicon.png" alt="logo-head" class="w-20 mx-auto mb-1" />
                    </header>
                    <div class="py-2">
                      <form @submit.prevent="handleLogin">
                        <div class="mb-3">
                          <label class="block text-medium font-semibold text-indigo-500" for="username">Email</label>
                          <input v-focus class="w-full rounded-lg p-2 text-indigo-700 focus:border-b-3 border-indigo-500 placeholder-indigo-600 outline-none shadow-md" type="text" name="username" v-model="username" @keyup.enter="handleLogin">
                          <span v-if="errorEmail" class="font-bold text-red-500 text-xs">Email harus diisi*</span>
                        </div>
                        <div class="mb-3">
                          <label class="block text-medium font-semibold text-indigo-500" for="password">Password</label>
                          <div class="relative">
                            <input class="w-full rounded-lg p-2 text-indigo-700 focus:border-b-3 border-indigo-500 placeholder-indigo-600 outline-none shadow-md" :type="show ? 'password' : 'text'" name="password" v-model="password" @keyup.enter="handleLogin">
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center text-lg leading-5 text-indigo-700">
                              <i @click="toggle" :class="show ? 'fas fa-eye' : 'fas fa-eye-slash '"></i>
                            </div>
                          </div>
                          <span v-if="errorPassword" class="font-bold text-red-500 text-xs">Password harus diisi*</span>
                        </div>
                        <div v-if="errorStatus" class="bg-red-200 relative text-red-600 py-3 px-3 rounded-lg">
                          <span class="font-bold text-sm">Gagal! <span class="font-medium">{{ errorMsg }}</span></span>
                        </div>
                        <div>          
                          <button
                            type="button"
                            class="mt-3 text-sm font-semibold 
                            bg-indigo-700 w-full text-white rounded-lg
                            px-6 py-3 block shadow-xl hover:text-white  hover:bg-indigo-900 outline-none focus:outline-none duration-300"
                            :class="loading ? 'cursor-wait' : 'cursor-pointer' "
                            @click="handleLogin"
                          >
                          <i v-if="loading" class="fas fa-spinner animate-spin mr-1"></i>
                          <span v-else>Let's Go</span>
                        </button>
                        </div>       
                      </form>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveAccessToken, saveRefreshToken, purgeAccessToken, purgeRefreshToken, saveMe } from "@/utils/accessToken";
import { authApi } from "@/api/auth"
import qs from "qs"

export default {
  name: "Login",
  data() {
    return {
      username: '',
      password: '',
      show: true,
      errorStatus: false,
      errorMsg: '',
      errorEmail: false,
      errorPassword: false,
      loading: false,
      token: '',
      redirect: ''
    }
  },
  created() {
    this.redirect = this.sanitizeRedirect(this.$route.query.redirect)
  },
  methods: {
    sanitizeRedirect(redirect) {
      const value = (redirect || '').trim()
      if (!value) {
        return ''
      }

      // Allow only internal app paths and block external/protocol-relative URLs.
      if (!value.startsWith('/') || value.startsWith('//')) {
        return ''
      }

      return value
    },
    async handleLogin() {
      this.errorStatus = false
      this.errorEmail = false
      this.errorPassword = false
      if(this.username && this.password ) {
        this.loading = true
        await authApi.login(qs.stringify({
          grant_type: 'password',
          username: this.username,
          password: this.password,
        })).then((res) => {
          this.errorStatus = false
          if( res.data ) {
            this.token = res.data.access_token
            saveAccessToken(res.data.access_token)
            saveRefreshToken(res.data.refresh_token)
          }
          return authApi.getMe(res.data.access_token)
        })
        .then((res) => {
          this.loading = false
          if(res.data.data.role_id == 1) {
            saveMe(res.data.data)
            if(this.redirect) {
              window.location.replace(this.redirect)
            } else {
              window.location.reload()
            }
          } else { 
            purgeAccessToken()
            purgeRefreshToken()
            this.errorStatus = true
            this.errorMsg = 'Ehem bukan admin ya?'
          }
        })
        .catch(error => {
          this.errorStatus = true
          if(error == 'Error: timeout of 5000ms exceeded') {
            this.errorMsg = 'Gateway Time-out calling Mr. H'
          } else {
            this.errorMsg = 'Ada yang typo gan?'
          }
          this.loading = false
        })
      } else {
        if(!this.username){
          this.errorEmail = true
        }
        if(!this.password) {
          this.errorPassword = true
        }
      }
    },
    toggle() {
      this.show = !this.show
    }
  }
};
</script>
<style scoped>
.w-login {
  width: 23vw;
}
@media (max-width: 768px) {
  .w-login {
    width: 50vw;
  } 
}
@media (max-width: 640px) {
  .w-login {
    width: 75vw;
  } 
}
</style>